import { Controller } from "@hotwired/stimulus"

//
//== FANCYBOX
import { Fancybox } from "@fancyapps/ui";

export default class extends Controller {
  static values = { url: String }


  connect () {
    Fancybox.bind("[data-fancybox]", {
      Toolbar: {
        display: {
          middle: [
            "zoomIn",
            "zoomOut",
            "toggle1to1",
          ],
          right: ["slideshow", "close"],
        },
      }
    })
  }

  disconnect () {
    Fancybox.destroy();
  }

  async open(event) {
    event.preventDefault();

    const url = event.currentTarget.dataset.fancyboxUrlValue;
    if (!url) return console.warn("Missing data-fancybox-url-value");

    console.log(url)

    try {
      const response = await fetch(url, {
        headers: { Accept: "application/json" },
      });
      if (!response.ok) throw new Error("Failed to load images");

      const images = await response.json();

      Fancybox.show(
        images.map((img) => ({
          src: img.url,
          caption: img.caption || "",
          type: "image",
        }))
      );
    } catch (error) {
      console.error("Gallery load error:", error);
    }
  }
}
